import { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  // ✅ Add scroll detection
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white text-black shadow-md" : "bg-transparent text-white"
      }`}
    >
      <div className="container mx-auto flex justify-between items-center py-4 px-6">
        <h1
          className="text-xl md:text-2xl font-bold"
          style={{ fontFamily: "Times New Roman, serif" }}
        >
          <Link href="/">SRK Trends</Link>
        </h1>

        <button
          className="block md:hidden focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth={2}>
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <nav className="hidden md:flex space-x-6 items-center">
          <Link href="/" className="hover:underline">Home</Link>
          <Link href="/womens" className="hover:underline">Womens</Link>
          <Link href="/mens" className="hover:underline">Mens</Link>
          <Link href="/m2measure" className="hover:underline">Made-to-Measure</Link>
          <Link href="/book-app" className="hover:underline">Book Appointment</Link>
          <Link href="/shop" className="hover:underline">Shop</Link>
          <Link href="/contact" className="hover:underline">Contact</Link>
        </nav>
      </div>

      {/* ✅ Mobile Menu */}
      {isMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-black text-white shadow-lg md:hidden">
          <nav className="flex flex-col items-center space-y-4 py-6">
            <Link href="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
            <Link href="/womens" onClick={() => setIsMenuOpen(false)}>Womens Collections</Link>
            <Link href="/mens" onClick={() => setIsMenuOpen(false)}>Mens Collections</Link>
            <Link href="/m2measure" onClick={() => setIsMenuOpen(false)}>Made-to-Measure</Link>
            <Link href="/book-app" onClick={() => setIsMenuOpen(false)}>Book An Appointment</Link>
            <Link href="/shop" onClick={() => setIsMenuOpen(false)}>Shop</Link>
            <Link href="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link>
          </nav>
        </div>
      )}
    </header>
  );
}